module.exports = __webpack_public_path__ + "static/img/3.a6c257a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/2/zh/3.png
// module id = og1Q
// module chunks = 0